// resetUserPassword.js
import axiosInstance from 'services/axiosMiddleware';

export async function resetUserPassword({ userid, password }) {
  try {
    const response = await axiosInstance.put(`users/${userid}/password`, { password });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}